import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { Firm } from '@/types';

type Props = {
  firms: Firm[];
  selectedFirmPid: string;
  onSelect: (firm: Firm) => void;
  disabled?: boolean;
};

export const FirmMenu: React.FC<Props> = ({
  firms,
  selectedFirmPid,
  onSelect,
  disabled = false,
}) => {
  const selectedFirm = firms.find((f) => f.pid === selectedFirmPid);

  const handleSelect = (firm: Firm): void => {
    onSelect(firm);
  };

  return (
    <>
      <Autocomplete
        size="small"
        disableClearable
        disabled={disabled}
        sx={{
          width: 270,
          '& .MuiAutocomplete-inputRoot': {
            width: 'fit-content',
            minWidth: '100%',
          },
          '& .MuiOutlinedInput-input::placeholder,.MuiAutocomplete-input': {
            color: 'text.secondary',
            textTransform: 'uppercase',
            opacity: 1,
            fontSize: 12,
            letterSpacing: '1.2px',
            fieldSizing: 'content',
            width: '100% !important',
          },
          '& .MuiAutocomplete-endAdornment': {
            display: disabled ? 'none' : 'flex',
            flexDirection: 'row-reverse',
          },
        }}
        renderInput={(params) => (
          <TextField {...params} placeholder="Select a firm" />
        )}
        options={firms}
        getOptionLabel={(option) => option.name}
        value={selectedFirm}
        onChange={(_, value) => handleSelect(value)}
      />
    </>
  );
};
